import { isAxiosError } from 'axios'

function readMessageFromResponseData(data: unknown): string | undefined {
  if (!data || typeof data !== 'object') {
    return undefined
  }
  const message = (data as { message?: unknown }).message
  return typeof message === 'string' && message.trim().length > 0 ? message : undefined
}

export function getApiErrorMessage(error: unknown): string {
  if (isAxiosError(error)) {
    const responseMessage = readMessageFromResponseData(error.response?.data)
    if (responseMessage) {
      return responseMessage
    }
  }
  if (error instanceof Error && error.message.trim().length > 0) {
    return error.message
  }
  return 'Unknown error'
}
